import React from 'react';
import PropTypes from 'prop-types';
import { SecuritizePage as Page } from '@securitize/ui-components';

const SecuritizePage = ({
  isLoading, isError, errorText, children, errorDisplay, isTranslationError,
}) => (
  <Page
    isLoading={isLoading}
    isError={isError}
    errorText={errorText}
    errorDisplay={errorDisplay}
    isTranslationError={isTranslationError}
  >
    {children}
  </Page>
);

SecuritizePage.propTypes = {
  isLoading: PropTypes.bool,
  isTranslationError: PropTypes.bool,
  isError: PropTypes.bool,
  errorText: PropTypes.string,
  children: PropTypes.node,
  errorDisplay: PropTypes.node,
};

SecuritizePage.defaultProps = {
  isLoading: true,
  isTranslationError: false,
  isError: false,
  errorText: undefined,
  children: [],
  errorDisplay: [],
};

export default SecuritizePage;
